import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export const useRequestDataExport = () => {
	return useMutation({
		mutationFn: async () => {
			try {
				return (await api.post('/user/data-export/request')).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao solicitar exportação de dados');
			}
		},
		onError: (error) => {
			console.error(
				'Erro ao solicitar exportação de dados:',
				getApiErrorMessage(error, 'Erro ao solicitar exportação de dados')
			);
		},
	});
};
